var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShuffleBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2230_2826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 6.6665L35 11.6665L30 16.6665",
    stroke: "#434289",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 33.333L35 28.333L30 23.333",
    stroke: "#434289",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 11.6665H10C12.2101 11.6665 14.3298 12.5445 15.8926 14.1073C17.4554 15.6701 18.3333 17.7897 18.3333 19.9998C18.3333 22.21 19.2113 24.3296 20.7741 25.8924C22.3369 27.4552 24.4565 28.3332 26.6667 28.3332H35",
    stroke: "#434289",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 26.6682C13.5582 27.7512 11.8032 28.3356 10 28.3332H5M35 11.6665H26.6667C24.8647 11.6636 23.1107 12.2475 21.67 13.3298L35 11.6665Z",
    stroke: "#434289",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2230_2826"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuffleBlue);
export default __webpack_public_path__ + "static/media/Shuffle-blue.5f15b068e6e93395944fc54eecd05e3d.svg";
export { ForwardRef as ReactComponent };